import useAndroidStatusBarH from "@/hooks/useAndroidStatusBarH";

// 沉浸式android 状态栏高度
export default function StatusBarHeight() {
  const { h } = useAndroidStatusBarH();

  return <div style={{ height: h }}></div>;
}
